import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/firestore";

export const app = firebase.initializeApp({
  apiKey: "AIzaSyAUObkuaFN07SI_3h3-7gJ5JrhGjhNAfZo",
  authDomain: "titoumr-fr.firebaseapp.com",
  projectId: "titoumr-fr",
  storageBucket: "titoumr-fr.firebasestorage.app",
  messagingSenderId: "282971287225",
  appId: "1:282971287225:web:da463952e699456b7bf568",
  measurementId: "G-1QNC22F7TK",
});
